'use client';

import { ReactNode } from 'react';
import * as styles from './action-buttons.css';

export const ActionRow = ({ children }: { children: ReactNode }) => (
  <div className={styles.row} data-id="order-complete-actions">
    {children}
  </div>
);
